<template>
  <div class="card-container">
    <div class="limit-size-card">
      <b-card>
        <template #header>
          <div class="welcome-bg">
            <div class="row">
              <div class="col-7">
                <div class="text-white py-4 ps-4 pe-3">
                  <slot name="title" />
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
        </template>
        <div>
          <router-link to="/">
            <div class="avatar-md profile-user-wid">
              <span class="avatar-title rounded-circle" style="background-color: #eff2f724 !important">
                <img src="@assets/images/logo-icon.svg" alt height="54" />
              </span>
            </div>
          </router-link>
        </div>
        <slot />
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>

<style lang="scss" scoped>
@import '@styles/variables.scss';

.welcome-bg {
  background: linear-gradient(90deg, #021f82 5%, #1b46d4 35%, #021f82 100%);
}

.card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
}

.limit-size-card {
  width: 100%;
  max-width: 456px;
  @media (max-width: 1200px) {
    max-width: 632px;
  }
  @media (max-width: 752px) {
    width: 100vw;
  }
  margin-bottom: 20vh;
}

:deep(.card-header) {
  padding: 0;
}

:deep(.card-body) {
  padding-top: 0;
}

:deep(.card) {
  overflow: hidden;
}

:global(body) {
  min-width: 100% !important;
  min-height: 100vh !important;
}
</style>
